(() => {
  if (customElements.get('selfwise-frontrow')) return;

  const providerOrigin = 'https://app.thefrontrowhealth.com';
  const scripts = new Map();
  function loadProvider(presentation) {
    if (!scripts.has(presentation)) {
      scripts.set(presentation, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `${providerOrigin}/api/widgets/script?presentation_type=${presentation}&product_id=5714`;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      }));
    }
    return scripts.get(presentation);
  }

  class SelfwiseFrontrow extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = (event) => {
        this.updateVariant(event.detail?.variant?.id);
        this.observeForm();
      };
      this.observeForm();
      if (this.dataset.placement === 'image') {
        this.imageArea = this.closest('.product-gallery__image-list');
        this.carousel = this.imageArea?.querySelector('.product-gallery__carousel');
        this.onMediaChange = (event) => {
          this.dataset.currentMedia = event.detail?.cell?.dataset.mediaId || '';
          this.updateVariant(this.dataset.selectedVariant);
        };
        this.carousel?.addEventListener('carousel:change', this.onMediaChange);
        this.resizeObserver = new ResizeObserver(() => {
          this.imageArea?.style.setProperty('--frontrow-image-badge-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
      }
      this.updateVariant(this.dataset.selectedVariant);
    }

    disconnectedCallback() {
      this.observedForm?.removeEventListener('variant:change', this.onVariantChange);
      this.carousel?.removeEventListener('carousel:change', this.onMediaChange);
      this.resizeObserver?.disconnect();
      this.imageArea?.classList.remove('has-frontrow-image-badge');
    }

    observeForm() {
      // Prestige emits on the old form after replacing its buy-buttons block.
      // Listen directly, then attach to the newly rendered form for the next change.
      this.observedForm?.removeEventListener('variant:change', this.onVariantChange);
      this.observedForm = document.getElementById(this.dataset.formId);
      this.observedForm?.addEventListener('variant:change', this.onVariantChange);
    }

    updateVariant(variantId) {
      this.dataset.selectedVariant = String(variantId || '');
      const isFeaturedImage = !this.imageArea || this.dataset.featuredMediaIds.split(',').includes(this.dataset.currentMedia);
      const eligible = Boolean(variantId) && isFeaturedImage;
      this.hidden = !eligible || Boolean(this.failed);
      this.imageArea?.classList.toggle('has-frontrow-image-badge', !this.hidden);
      if (!eligible || this.failed) return;
      if (!this.mounted) this.mount();
      this.iframe?.contentWindow?.postMessage({ name: 'PARENT_READY' }, providerOrigin);
    }

    async mount() {
      this.mounted = true;
      const presentation = this.dataset.presentation;
      const badge = presentation === 'quant';
      const iframe = document.createElement('iframe');
      iframe.id = badge ? (this.imageArea ? 'iframe-frontrow-image' : 'iframe-frontrow-quant') : 'frontrow-testimonials';
      iframe.className = badge ? 'iframe-frontrow' : 'iframe-frontrow-testimonials';
      iframe.title = badge ? (this.imageArea ? 'FrontrowMD main product image badge' : 'FrontrowMD clinician sharing badge') : 'FrontrowMD independent clinician evaluations';
      iframe.setAttribute('frameborder', '0');
      this.iframe = iframe;
      this.append(iframe);
      try {
        // Load the provider's unmodified event handlers before its iframe sends sizing messages.
        await loadProvider(presentation);
        if (!this.isConnected) return;
        iframe.src = `${providerOrigin}/api/widgets?presentation_type=${presentation}&product_id=5714`;
      } catch {
        this.failed = true;
        this.hidden = true;
        this.imageArea?.classList.remove('has-frontrow-image-badge');
      }
    }
  }

  customElements.define('selfwise-frontrow', SelfwiseFrontrow);
})();
